import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, LockIcon, ShieldCheckIcon, StarIcon, TruckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { useLiveViewers } from '../hooks/useLiveViewers';
import { offer } from '../data/offer';
const trustBadges = [{
  icon: TruckIcon,
  label: 'Consegna immediata'
}, {
  icon: LockIcon,
  label: 'Pagamento sicuro'
}, {
  icon: ShieldCheckIcon,
  label: 'Garanzia di 30 giorni'
}];
export function HeroSection() {
  const viewers = useLiveViewers();
  return <section id="top" className="bg-brand-main px-4 py-10 md:py-14" data-id="element-99" data-mp="30k0weybdv4dk">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center text-center" data-id="element-100" data-mp="2muffrul2318p">
        <p className="inline-flex items-center gap-2 rounded-full bg-brand-red/10 px-3 py-1 text-[10px] font-extrabold tracking-[0.16em] text-brand-red sm:text-xs" data-id="element-101" data-mp="3fgi5tk00i8xh">
          OFFERTA VALIDA PER OGGI
        </p>

        <h1 className="mt-4 max-w-4xl text-[2.1rem] font-extrabold leading-[1.06] tracking-tight text-brand-deep sm:text-[2.9rem] md:text-[3.2rem]" data-id="element-102" data-mp="2fd5z1uuqznju">
          Insegna Geografia con <span className="italic text-brand-ocean" data-id="element-103" data-mp="2p6mq4r3i2ojt">sicurezza</span>: lezioni pronte, concrete
          e adatte alla tua classe
        </h1>

        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-104" data-mp="2z39azfvttflu">
          Dalla 1ª Primaria alla 3ª Media, con percorsi da stampare che ti fanno smettere di improvvisare e iniziare
          a guidare davvero.
        </p>

        <img src="https://cdn.magicpatterns.com/uploads/65Hx84feYv7yCGeXujzEs2/MOCKUP.png" alt="Il pacchetto GEOGRAFIA PRONTA: gli 8 volumi dalla 1ª primaria alla 3ª media, i materiali digitali e i 5 bonus inclusi" className="my-8 w-full max-w-xl rounded-3xl object-contain md:max-w-2xl" data-id="element-105" data-mp="383efni9mxzwb" />

        <div className="flex flex-col items-center gap-3" data-id="element-106" data-mp="38tbb3to1oap1">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-alt px-3 py-1.5 text-xs font-bold text-brand-text shadow-sm" data-id="element-107" data-mp="38uw6fli6nxny">
            <span className="flex" aria-hidden="true" data-id="element-108" data-mp="3irr1fuf8zfxh">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-brand-amber text-brand-amber" data-id="element-109" data-mp="3msud04q9ipsw" />)}
            </span>
            4.9 <span className="font-semibold text-brand-gray" data-id="element-110" data-mp="3rre56mvg8xtp">(500+ vendite)</span>
          </span>
          <p className="flex items-baseline justify-center gap-3" data-id="element-111" data-mp="kl37gsu0uo4">
            <span className="font-display text-5xl font-extrabold tracking-tight text-brand-deep" data-id="element-112" data-mp="5c2t99tbhaub">
              {offer.todayPrice}
            </span>
            <span className="text-base font-bold text-brand-gray line-through" data-id="element-113" data-mp="aaw7j4gfh5vj">{offer.totalValue}</span>
            <span className="rounded-full bg-brand-ocean/10 px-2 py-0.5 text-[11px] font-extrabold text-brand-ocean" data-id="element-114" data-mp="ef3w91mvyltr">
              -{offer.discount}
            </span>
          </p>
        </div>

        <CTAButton className="mt-6 w-full px-6 py-4 sm:w-auto sm:px-10" data-id="element-115" data-mp="23vptjh5pl8jh">
          Porta a casa GEOGRAFIA PRONTA™ ora
        </CTAButton>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-116" data-mp="1utggokmyx32x">
          {trustBadges.map(({
          icon: BadgeIcon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 text-[11px] font-semibold text-brand-gray" data-id="element-117" data-mp="1pw818rt7fd5d">
              <BadgeIcon className="h-3.5 w-3.5 text-brand-ocean" aria-hidden="true" data-id="element-118" data-mp="2mn0frl0hox51" />
              {label}
            </li>)}
        </ul>

        <p className="mt-4 flex items-center justify-center gap-2 text-[11px] font-semibold text-brand-gray" aria-live="polite" data-id="element-119" data-mp="2drsske59kr27">
          <EyeIcon className="h-3.5 w-3.5 text-brand-amber" aria-hidden="true" data-id="element-120" data-mp="28szotdfs4ef8" />
          <span className="tabular-nums" data-id="element-121" data-mp="369yeao2axbr5">{viewers}</span> persone stanno guardando questo prodotto in questo momento
        </p>
      </motion.div>
    </section>;
}